<template>
    <a
        href="javascript: void(0);"
        class="action-icon"
        @click="$emit('onClick')">
        <i class="fe-more-vertical icon-blue"/>
    </a>
</template>

<script>
export default {}
</script>
